import { Scene, Group, PointLight, PointLightHelper, Vector3, WebGLRenderer, Camera } from 'three'

export default class PositionHelper {

    elId = "pointerPosition"

    renderer: WebGLRenderer
    camera: Camera


    constructor(renderer: WebGLRenderer, camera: Camera) {
        // this.scene = scene
        this.renderer = renderer
        this.camera = camera

    }

    activate = () => {
        const div = document.createElement('div')

        div.id = this.elId

        const styles = {
            position: "fixed",
            bottom: "5px",
            left: "5px",
            display: "flex",
            width: "200px",
            height: "50px",
            justifyContent: "space-around",
            alignItems: "center",
            background: "#5c5353",
            borderRadius: "10px",
            color: "white"
        }

        for (const key in styles) {
            // @ts-ignore
            div.style[key] = styles[key]
        }

        div.onclick = () => this.deactivate()

        document.body.appendChild(div)

        window.addEventListener("mousemove", this.pickPosition)
    }

    deactivate = () => {
        const el = document.getElementById(this.elId)

        if (el) {
            document.body.removeChild(el)
        }

        window.removeEventListener("mousemove", this.pickPosition)

    }

    pickPosition = (e: MouseEvent) => {
        const pos = this.getSceneToWorld(e.clientX, e.clientY)

        const el = document.getElementById(this.elId)

        if (el) {
            el.innerHTML = `<div>${pos.x.toFixed(2)}</div><div>${pos.y.toFixed(2)}</div><div>${pos.z.toFixed(2)}</div>`
        }
    }

    getSceneToWorld = (dx: number, dy: number) => {
        var vec = new Vector3(); // create once and reuse
        var pos = new Vector3(); // create once and reuse

        if (this.renderer.domElement.parentElement)
            vec.set(
                ((dx - this.renderer.domElement.parentElement.offsetLeft) / this.renderer.domElement.clientWidth) * 2 - 1,
                - ((dy - this.renderer.domElement.parentElement.offsetTop) / this.renderer.domElement.clientHeight) * 2 + 1,
                0.5);

        vec.unproject(this.camera);

        vec.sub(this.camera.position).normalize();

        var distance = - this.camera.position.z / vec.z;

        pos.copy(this.camera.position).add(vec.multiplyScalar(distance))

        return pos
    }

}